import type {
  ChatMessage,
  FollowUpType,
} from '@ben/columbia/components/assistant/types';

export class BaseAIAction {
  label: string;
  requiresUserPrompt: boolean;
  executed: boolean;
  firstMessage?: string;
  externalSetValue?: (value: string) => void;
  // additional args to pass to the Agent (specific for each action)
  args?: unknown[];
  // additional context
  chatMessages?: ChatMessage[];

  constructor() {
    this.label = '';
    this.requiresUserPrompt = false;
    this.executed = false;
  }

  trigger(): Promise<[FollowUpType, unknown][]> {
    throw new Error('Method not implemented.');
  }
}
